export class LoginResponseModel {
  id: number;
  userName: string;
  token: string;
  expires: number;
  refreshToken: string;
}
